import styled from 'styled-components';

export const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;

  .MuiTimelineItem-root:before {
    display: none;
  }
  .MuiTimelineOppositeContent-root {
    display: none;
  }
  .MuiAutocomplete-inputRoot {
    flex-wrap: nowrap;
  }
  .MuiTimelineContent-root {
    padding: 0px 16px;
  }
  .MuiAutocomplete-hasPopupIcon .MuiOutlinedInput-root,
  .MuiAutocomplete-hasClearIcon .MuiOutlinedInput-root {
    padding-right: 12px !important;
  }
`;
